// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 380px) {
    .scl--web-page-product-hero-section .scl--web-component-hero-title-line1{
        font-size: 40px;
    }

    .scl--web-page-product-hero-section .scl--web-component-hero-title-line2{
        font-size: 40px;
    }

    .scl--web-page-product-hero-section .scl--web-component-hero-title{
        line-height: 45px;
        padding: 0;
        margin: 0;
    }

    .scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button{
        margin-top: 20px;
        width: 185px;
    }

    .scl--web-page-product-hero-section-container{
        margin-top: 40px;
    }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/product/css/productSm.css"],"names":[],"mappings":"AAAA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,UAAU;QACV,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["@media (max-width: 380px) {\n    .scl--web-page-product-hero-section .scl--web-component-hero-title-line1{\n        font-size: 40px;\n    }\n\n    .scl--web-page-product-hero-section .scl--web-component-hero-title-line2{\n        font-size: 40px;\n    }\n\n    .scl--web-page-product-hero-section .scl--web-component-hero-title{\n        line-height: 45px;\n        padding: 0;\n        margin: 0;\n    }\n\n    .scl--web-page-product-hero-section-container .scl--web-component-hero-content .scl--web-component-round-button{\n        margin-top: 20px;\n        width: 185px;\n    }\n\n    .scl--web-page-product-hero-section-container{\n        margin-top: 40px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
